module.exports = __webpack_public_path__ + "static/img/order_message@3x.9b73ba8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/order_message@3x.png
// module id = wte9
// module chunks = 1